var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"Footer"},[_c('p',{staticClass:"Footer__copyright"},[_vm._v("Miko Sramek © 2020")])])}]

export { render, staticRenderFns }